import { takeLatest, call, put } from 'redux-saga/effects';

import commonActionTypes from './action-types';
import { getConfigurations } from './api';
import { fetchConfigurationsSuccess, fetchConfigurationsFail } from './actions';

function* fetchConfigurationsSaga() {
  try {
    const response = yield call(getConfigurations);
    yield put(fetchConfigurationsSuccess(response?.data?.data));
  } catch (error) {
    console.log(error);
    yield put(fetchConfigurationsFail(error));
  }
}

function* commonSaga() {
  yield takeLatest(commonActionTypes.FETCH_CONFIGURATIONS, fetchConfigurationsSaga);
}

export default commonSaga;
